import { AppState } from 'Store'

const getEntries = (state: AppState) => state.som.sms.data.entries
const getTotal = (state: AppState) => state.som.sms.data.total_entries
const getParams = (state: AppState) => state.som.sms.requestParams

export const smsSelector = {
	getEntries,
	getParams,
	getTotal,
}
